import SectionHeading from "@/components/feature/SectionHeading";
import { Link } from "react-router-dom";
import { introFeatures } from "@/mocks/home";

export default function IntroSection() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <SectionHeading
              eyebrow="关于大赛"
              title="用群众打分，选出真正出圈的名场面"
            />
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              爆料大赛不是由少数评委说了算的榜单。我们把评分权交回给网友，每一件入围作品都由大家匿名打分，去掉最高分与最低分后取平均，最终形成公开、可追溯的排名结果。
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              从名场面到高能反转，从幕后花絮到神评论截图，不同风格的作品分属不同分类独立角逐。你既能围观群众打分走势，也能亲手为自己认可的作品投上一票。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-6 text-sm font-bold text-primary-600 hover:text-primary-700 transition-colors"
            >
              了解活动的评选原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="order-1 lg:order-2 rounded-lg overflow-hidden border border-background-200 w-full h-[280px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20crowd%20of%20anonymous%20people%20holding%20score%20cards%20in%20a%20bright%20arena%2C%20warm%20cream%20background%20with%20vivid%20red%20and%20gold%20accents%2C%20bold%20geometric%20poster%20composition%2C%20celebratory%20mood&width=1000&height=1100&seq=baoliao-intro-01&orientation=portrait"
              alt="网友手持打分牌参与爆料大赛评选的插画"
              title="爆料大赛群众打分评选现场"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mx-auto max-w-6xl mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {introFeatures.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
            >
              <span className="w-12 h-12 rounded-md bg-primary-50 text-primary-600 mb-4 flex items-center justify-center text-2xl">
                <i className={feature.icon} />
              </span>
              <h3 className="font-heading text-lg tracking-wide text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}